import React from 'react';
import './Gift.css';

const PromotionsGiftcards = () => {
  return (
    <>
      <h1 className="text-center pt-4"
      style={{color: '#b37777',fontStyle: 'italic',fontFamily: "'TAN TWINKLE', cursive",}}>Promotions</h1>

      <div className="container d-flex">
        <div className="card animate-form text-center " style={{maxHeight:'370px' ,lineHeight:'',borderRadius:'15px'}}>
          <h1>Exclusive Offers</h1>
          <h1>🌟</h1>
          <p className='' style={{lineHeight:'1.2'}}>First-Time Clients: Enjoy 20% Off Your First Service!</p>
          <p>🎉</p>
          <small>
            <button className="offer-btn" onClick={() => alert('Discount Claimed!')}>
              Claim Your Discount
            </button>
          </small>
        </div>

        <div className="card animate-form1 text-center" style={{borderRadius:'15px'}}>
          <h1>Holiday Special</h1>
          <h1>🎄</h1>
          <p style={{lineHeight:'1.2'}}>
            Contact <span style={{ color: '#f0b1b1' }}>medina@frontiersgi.com</span> for special holiday offers.
          </p>
          <p>🌟</p>
        </div>
      </div>
<div className='giftcard'>
      <div className="gift-card-container animate-form ">
        <h2 className="mb-4">GIFT CARD</h2>
        <div className="gift-card">
          <p className="gift-card-header text-center">A GIFT FOR YOU</p>
          <form>
            <div className="mb-3 row giftrow">
              <div className="col-sm-6 ">
                <input
                  type="text"
                  className="form-control gift-card-input"
                  id="toName"
                  placeholder="To:"
                  aria-label="Recipient Name"
                />
              </div>
              <div className="col-sm-6">
                <input
                  type="text"
                  className="form-control gift-card-input"
                  id="fromName"
                  placeholder="From:"
                  aria-label="Sender Name"
                />
              </div>
            </div>
            <div className="mb-3 row giftrow">
              <div className="col-sm-6">
                <input
                  type="text"
                  className="form-control gift-card-input"
                  id="value"
                  placeholder="$100"
                  aria-label="Gift Card Value"
                />
              </div>
              <div className="col-sm-6">
                <input
                  type="date"
                  className="form-control gift-card-input"
                  id="validity"
                  aria-label="Gift Card Validity Date"
                />
              </div>
            </div>
            <div className="mb-3 row giftrow">
              <div className="col-sm-12">
                <input
                  type="text"
                  className="form-control gift-card-input"
                  id="signature"
                  placeholder="MSilkspa Signature"
                  aria-label="Gift Card Signature"
                />
              </div>
            </div>
          </form>
        </div>
        <p className="footer-text">
          “Give the gift of beauty and relaxation with an MSilk Spa gift card—perfect for any occasion.”
        </p>
      </div>
      </div>
      <div className='p-2'></div>
    </>
  );
};

export default PromotionsGiftcards;
